module.exports = __webpack_public_path__ + "media/images/app/visitors/couture/how-it-works/step3-6a8729d95ff8ac9eaafe0cdd68b405a9.svg";